import React from 'react'
import { deleteFridgeFood } from '../../components/shared/database'

const FridgeEatenButton = ({
    foodInFridge,
}) => {
    if ((foodInFridge?.countFood ?? 1) > 1) {
        return (
            <div className="btn-group">
                <button onClick={() => deleteFridgeFood(foodInFridge.uid)} className="btn btn-outline-danger">
                    <i className="fas fa-cookie-bite mr-2"></i>
                    Ujedeno
                </button>
                <button onClick={() => deleteFridgeFood(foodInFridge.uid, true)} className="btn btn-outline-danger">
                    <i className="fas fa-utensils mr-2"></i>
                    Snězeno
                </button>
            </div>
        )
    }

    return (
        <button onClick={() => deleteFridgeFood(foodInFridge.uid, true)} className="btn btn-outline-danger">
            <i className="fas fa-utensils mr-2"></i>
            Snězeno
        </button>
    )
}

export default FridgeEatenButton
